import typeToReducer from 'type-to-reducer';

import * as actions from "../actions";

const iniState = {
  loaded: false,
  results: [],
  error: false,
  loading: false
}

export const address = typeToReducer({
  [actions.GET_ADDRESS]: {
    PENDING: () => ({
      ...iniState,
      loading: true
    }),
    REJECTED: (state) => ({
      ...state,
      error: true,
      loading: false,
      loaded: true
    }),
    FULFILLED: (state, action) => ({
      ...state,
      results: action.payload.data,
      error: false,
      loading: false,
      loaded: true
    })
  },
  [actions.CLEANUP_ADDRESS]: () => ({
    ...iniState
  })
}, iniState);
